import APIConfiguration from '@savgroup-front-common/configuration/api';
import { COMMON_QUERY_PARAMS } from '@savgroup-front-common/constants';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared/supportedMethods';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.carrier}sellers/${COMMON_QUERY_PARAMS.SELLER_ID}/carriers/genericAccount/pricing`;

interface UpsertPricingForGenericCarrierAccountCommandValues {
  isTransportPricingEnabled: boolean;
  xsPrice: number;
  xlPrice: number;
  isDeductible: boolean;
  isSelfDepositEnabled: boolean;
  isOutOfWarrantyEnabled: boolean;
  outOfWarrantyAmount: number;
  isOutOfWarrantyDeductible: boolean;
}

interface UpsertPricingForGenericCarrierAccountCommandArgs {
  sellerId: string;
  data: UpsertPricingForGenericCarrierAccountCommandValues;
}

const upsertPricingForGenericCarrierAccountCommand = async ({
  sellerId,
  data,
}: UpsertPricingForGenericCarrierAccountCommandArgs): Promise<
  | BackResponse<UpsertPricingForGenericCarrierAccountCommandValues>
  | BackResponseFailure
> => {
  try {
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.SELLER_ID, sellerId);

    const response = await apiCall<
      BackResponse<UpsertPricingForGenericCarrierAccountCommandValues>
    >(url, {
      method: SUPPORTED_METHODS.POST,
      json: data,
    });

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
};

export default upsertPricingForGenericCarrierAccountCommand;
